"use strict";

const backToTop = document.querySelector('[data-js="backToTop"]');

if (backToTop) {
	window.addEventListener("scroll", backToTopVisible);

	function backToTopVisible() {
		if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
			backToTop.classList.add("show");
		} else {
			backToTop.classList.remove("show");
		}
	}

	function backToTopScroll() {
		backToTop.addEventListener("click", function (e) {
			e.preventDefault();
			document.querySelector("body").scrollIntoView({behavior: "smooth"});
		}, false);
	}
	backToTopScroll();
}